export function formatPhoneNumber(phone) {
  if (!phone) return null;

  const cleaned = ("" + phone).replace(/\D/g, "");
  const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);

  return match ? `(${match[1]}) ${match[2]}-${match[3]}` : phone;
}

export default {
  formatPhoneNumber,
};
